// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";

import { ChatProvider } from "./contexts/ChatContext";
import Layout from "./components/Layout";
import LoginForm from "./pages/LoginForm";
import RegisterForm from "./pages/RegisterForm";
import Profile from "./pages/AlumniProfile";
import AlumniDirectory from "./pages/AlumniDirectory";
import AlumniDetails from "./pages/AlumniDetails";
import JobList from "./pages/JobList";
import JobDetails from "./pages/JobDetails";
import CreateJobPost from "./pages/CreateJobPost";
import EditProfile from "./pages/EditProfile";
import EventList from "./pages/EventList";
import EventDetails from "./pages/EventDetails";
import CreateEvent from "./pages/CreateEvent";
import CampaignList from "./pages/CampaignList";
import CreateCampaign from "./pages/CreateCampaign";
import CampaignDetails from "./pages/CampaignDetails";
import Home from "./pages/Home";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChatPage from "./pages/ChatPage";
import ConnectionRequests from "./components/ConnectionRequest";
import AnalyticsModal from "./components/AnalyticsModal";
import SuccessStory from "./pages/SuccessStory";
import AlumniSurvey from "./pages/AlumniSurvey";
import AlmaMap from "./pages/AlmaMap";
import FeedbackForm from "./pages/FeedbackForm";
import NewsletterList from "./pages/NewsletterList";
import NewsletterDetail from "./pages/NewsletterDetail";
import AlmaCardPage from "./pages/AlmaCardPage";
import NotFound from "./pages/NotFound";

const App = () => {
  return (
    <Router>
      <ChatProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            <Route
              path="/"
              element={
      
                  <Home />
       
              }
            />
            <Route
              path="/directory"
              element={
                <Layout>
                  <AlumniDirectory />
                </Layout>
              }
            />
            <Route
              path="/alumni/:id"
              element={
                <Layout>
                  <AlumniDetails />
                </Layout>
              }
            />
            <Route
              path="/jobs"
              element={
                <Layout>
                  <JobList />
                </Layout>
              }
            />
            <Route
              path="/jobs/:id"
              element={
                <Layout>
                  <JobDetails />
                </Layout>
              }
            />
            <Route
              path="/jobs/create"
              element={
                <Layout>
                  <CreateJobPost />
                </Layout>
              }
            />
            <Route
              path="/jobs/edit/:id"
              element={
                <Layout>
                  <CreateJobPost />
                </Layout>
              }
            />
            <Route
              path="/events"
              element={
                <Layout>
                  <EventList />
                </Layout>
              }
            />
            <Route
              path="/events/:id"
              element={
                <Layout>
                  <EventDetails />
                </Layout>
              }
            />
            <Route
              path="/events/create"
              element={
                <Layout>
                  <CreateEvent />
                </Layout>
              }
            />
            <Route
              path="/events/edit/:id"
              element={
                <Layout>
                  <CreateEvent />
                </Layout>
              }
            />
            <Route
              path="/campaigns"
              element={
                <Layout>
                  <CampaignList />
                </Layout>
              }
            />
            <Route
              path="/campaigns/create"
              element={
                <Layout>
                  <CreateCampaign />
                </Layout>
              }
            />
            <Route
              path="/campaigns/edit/:id"
              element={
                <Layout>
                  <CreateCampaign />
                </Layout>
              }
            />
            <Route
              path="/campaigns/:id"
              element={
                <Layout>
                  <CampaignDetails />
                </Layout>
              }
            />
            <Route
              path="/profile/edit"
              element={
                <Layout>
                  <EditProfile />
                </Layout>
              }
            />
            <Route
              path="/profile"
              element={
                <Layout>
                  <Profile />
                </Layout>
              }
            />
            <Route
              path="/connections/requests"
              element={
                <Layout>
                  <ConnectionRequests />
                </Layout>
              }
            />
            <Route
              path="/chat"
              element={
                <Layout>
                  <ChatPage />
                </Layout>
              }
            />
            <Route
              path="/chat/:id"
              element={
                <Layout>
                  <ChatPage />
                </Layout>
              }
            />
            <Route
              path="/success-stories"
              element={
                <Layout>
                  <SuccessStory />
                </Layout>
              }
            />
            <Route
              path="/survey"
              element={
                <Layout>
                  <AlumniSurvey />
                </Layout>
              }
            />
            <Route
              path="/alumni/analytics"
              element={
                <Layout>
                  <AnalyticsModal />
                </Layout>
              }
            />
            <Route
              path="/alumni-map"
              element={
                <Layout>
                  <AlmaMap />
                </Layout>
              }
            />
            <Route
              path="/feedback"
              element={
                <Layout>
                  <FeedbackForm />
                </Layout>
              }
            />
            <Route
              path="/newsletters"
              element={
                <Layout>
                  <NewsletterList />
                </Layout>
              }
            />
            <Route
              path="/newsletter/:id"
              element={
                <Layout>
                  <NewsletterDetail />
                </Layout>
              }
            />
            <Route
              path="/alma-card"
              element={
                <Layout>
                  <AlmaCardPage />
                </Layout>
              }
            />
            <Route
              path="*"
              element={
                <Layout>
                  <NotFound />
                </Layout>
              }
            />
          </Route>
        </Routes>
      </ChatProvider>
    </Router>
  );
};

const PrivateRoute = () => {
  const isAuthenticated = localStorage.getItem("token") !== null;
  const userRole = localStorage.getItem("userRole");

  if (!isAuthenticated || userRole !== "alumni") {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default App;
